/* Shared by Dialog and AlertDialog. Modals scale from the centre (not from the trigger). */
.backdrop {
  position: fixed;
  inset: 0;
  background: var(--color-overlay);
  transition: opacity var(--duration-slow) var(--easing-standard);
}

.backdrop[data-starting-style],
.backdrop[data-ending-style] {
  opacity: 0;
}

@supports (-webkit-touch-callout: none) {
  .backdrop {
    position: absolute;
  }
}

.viewport {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

.popup {
  display: flex;
  flex-direction: column;
  inline-size: min(100%, var(--dialog-md));
  max-block-size: calc(100dvh - var(--space-8));
  overflow: hidden;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
  color: var(--color-text);
  box-shadow: var(--shadow-modal);
  outline: 0;
  transition:
    opacity var(--duration-slow) var(--easing-standard),
    transform var(--duration-slow) var(--easing-standard);
}

.popup[data-size="sm"] {
  inline-size: min(100%, var(--dialog-sm));
}

.popup[data-size="lg"] {
  inline-size: min(100%, var(--dialog-lg));
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(var(--motion-scale));
}

.header {
  display: flex;
  gap: var(--space-4);
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--space-5) var(--space-5) 0;
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.title {
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-tight);
  line-height: var(--leading-tight);
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-md);
  line-height: var(--leading-normal);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4) var(--space-5);
  overflow-y: auto;
  font-size: var(--text-lg);
  line-height: var(--leading-normal);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  justify-content: flex-end;
  padding: var(--space-4) var(--space-5) var(--space-5);
}

.header + .footer {
  padding-block-start: var(--space-6);
}
